export enum PRODUCT_TYPE {
    BOX = 'box',
    FAIM = 'faim',
    FAIM_PREMIUM = 'faim_premium',
    FAIM_UNLIMITED = 'faim_unlimited',
    FAI = 'fai',
    FAI_SERVICE = 'fai_service',
    SOWO = 'sowo',
    PHONE_SIMPLE = 'phone_simple',
    PHONE_SOWO = 'phone_sowo',
    PLAN_IDEO = 'plan_ideo',
    PLAN_IDEO_PRO = 'plan_ideo_pro',
    PLAN_SOWO = 'plan_sowo',
    PLAN_SOWO_RENEW = 'plan_sowo_renew',
    PLAN_PREMIUM = 'plan_premium',
    PLAN_PREMIUM_RENEW = 'plan_premium_renew',
    OPTION = 'option',
    ACCESSORY = 'accessory',
}
